//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
    props: {
        title: String,
        content: String,
        showCancel: Boolean,
        textAlign: {
            type: String,
            default: 'left'
        },
        cancelText: {
            type: String,
            default: '取消'
        },
        confirmText: {
            type: String,
            default: '确认提交'
        },
        showConfirm: {
            type: Boolean,
            default: true
        },
    },
}
